import { MARKETPLACE_URLS } from '../config'

export const ALLOWED_MARKETPLACE_DOMAINS = [
  'staging.marketplace.gohighlevel.com',
  'marketplace.gohighlevel.com',
  'marketplace.leadconnectorhq.com',
  'staging.marketplace.leadconnectorhq.com'
]

export function setMarketplaceCookie(authToken: string) {
  const hostName = window.location.hostname.split('.')
  const hostLength = hostName.length
  let domainName = 'localhost'
  
  if (hostName[0] !== 'localhost') {
    domainName = `.${hostName[hostLength - 2]}.${hostName[hostLength - 1]}`
    document.cookie = `m_a=${authToken};domain=${domainName};path=/;max-Age=86400;secure;`
  }
}

export function handleMarketplaceRedirect(redirectUrl: string) {
  try {
    const url = new URL(redirectUrl)
    if (ALLOWED_MARKETPLACE_DOMAINS.includes(url.hostname) &&
      !url.protocol.startsWith('javascript:') &&
      !url.protocol.startsWith('data:')) {
      window.location.replace(url.toString())
    } else {
      console.error('Invalid redirect URL detected')
    }
  } catch(e) {
    console.error('Invalid URL format in redirect parameter')
  }
}

export function isMarketplaceRedirect() {
  return window?.location?.search?.includes('src=marketplace')
}

export function isMarketplaceOrigin(origin: string) {
  return (process.env.NODE_ENV === 'production' && MARKETPLACE_URLS.PRODUCTION.includes(origin)) || 
         (process.env.NODE_ENV === 'staging' && MARKETPLACE_URLS.STAGING.includes(origin)) ||
         (process.env.NODE_ENV === 'interop' && MARKETPLACE_URLS.INTEROP.includes(origin))
} 